/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkApplyCatalogPriceChangesDto } from '../models/work-apply-catalog-price-changes-dto';
import { WorkCatalogImportProgressDto } from '../models/work-catalog-import-progress-dto';
import { WorkCatalogPriceChangeDto } from '../models/work-catalog-price-change-dto';
import { WorkCatalogSummaryDto } from '../models/work-catalog-summary-dto';
import { WorkContact } from '../models/work-contact';
import { WorkCreateVendorContactFromCatalogDto } from '../models/work-create-vendor-contact-from-catalog-dto';
import { WorkIghCatalogListEntryDto } from '../models/work-igh-catalog-list-entry-dto';
import { WorkPaginatedCatalogItemsDto } from '../models/work-paginated-catalog-items-dto';
import { WorkPromoteCatalogItemsDto } from '../models/work-promote-catalog-items-dto';
import { WorkPromoteCatalogItemsPreviewDto } from '../models/work-promote-catalog-items-preview-dto';
import { WorkPromoteCatalogItemsPreviewResultDto } from '../models/work-promote-catalog-items-preview-result-dto';
import { WorkPromoteCatalogItemsResultDto } from '../models/work-promote-catalog-items-result-dto';
import { WorkStartCatalogImportDto } from '../models/work-start-catalog-import-dto';

@Injectable({ providedIn: 'root' })
export class WorkItemCatalogsV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `itemCatalogsV2ControllerFindIghList()` */
  static readonly ItemCatalogsV2ControllerFindIghListPath = '/v2/item-catalogs/igh-list';

  /**
   * Required permissions: items:read, items:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `itemCatalogsV2ControllerFindIghList()` instead.
   *
   * This method doesn't expect any request body.
   */
  itemCatalogsV2ControllerFindIghList$Response(
    params?: {
      search?: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkIghCatalogListEntryDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkItemCatalogsV2Service.ItemCatalogsV2ControllerFindIghListPath, 'get');
    if (params) {
      rb.query('search', params.search, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkIghCatalogListEntryDto>>;
      })
    );
  }

  /**
   * Required permissions: items:read, items:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `itemCatalogsV2ControllerFindIghList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  itemCatalogsV2ControllerFindIghList(
    params?: {
      search?: string;
    },
    context?: HttpContext
  ): Observable<Array<WorkIghCatalogListEntryDto>> {
    return this.itemCatalogsV2ControllerFindIghList$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkIghCatalogListEntryDto>>): Array<WorkIghCatalogListEntryDto> => r.body)
    );
  }

  /** Path part for operation `itemCatalogsV2ControllerFindAll()` */
  static readonly ItemCatalogsV2ControllerFindAllPath = '/v2/item-catalogs';

  /**
   * Required permissions: items:read, items:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `itemCatalogsV2ControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  itemCatalogsV2ControllerFindAll$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkCatalogSummaryDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkItemCatalogsV2Service.ItemCatalogsV2ControllerFindAllPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkCatalogSummaryDto>>;
      })
    );
  }

  /**
   * Required permissions: items:read, items:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `itemCatalogsV2ControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  itemCatalogsV2ControllerFindAll(
    params?: {
    },
    context?: HttpContext
  ): Observable<Array<WorkCatalogSummaryDto>> {
    return this.itemCatalogsV2ControllerFindAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkCatalogSummaryDto>>): Array<WorkCatalogSummaryDto> => r.body)
    );
  }

  /** Path part for operation `itemCatalogsV2ControllerFindPriceChanges()` */
  static readonly ItemCatalogsV2ControllerFindPriceChangesPath = '/v2/item-catalogs/price-changes';

  /**
   * Required permissions: items:read, items:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `itemCatalogsV2ControllerFindPriceChanges()` instead.
   *
   * This method doesn't expect any request body.
   */
  itemCatalogsV2ControllerFindPriceChanges$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkCatalogPriceChangeDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkItemCatalogsV2Service.ItemCatalogsV2ControllerFindPriceChangesPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkCatalogPriceChangeDto>>;
      })
    );
  }

  /**
   * Required permissions: items:read, items:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `itemCatalogsV2ControllerFindPriceChanges$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  itemCatalogsV2ControllerFindPriceChanges(
    params?: {
    },
    context?: HttpContext
  ): Observable<Array<WorkCatalogPriceChangeDto>> {
    return this.itemCatalogsV2ControllerFindPriceChanges$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkCatalogPriceChangeDto>>): Array<WorkCatalogPriceChangeDto> => r.body)
    );
  }

  /** Path part for operation `itemCatalogsV2ControllerFindItems()` */
  static readonly ItemCatalogsV2ControllerFindItemsPath = '/v2/item-catalogs/items';

  /**
   * Required permissions: items:read, items:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `itemCatalogsV2ControllerFindItems()` instead.
   *
   * This method doesn't expect any request body.
   */
  itemCatalogsV2ControllerFindItems$Response(
    params: {
      catalogId: number;
      page?: number;
      limit?: number;
      search?: string;
      categoryPath?: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkPaginatedCatalogItemsDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkItemCatalogsV2Service.ItemCatalogsV2ControllerFindItemsPath, 'get');
    if (params) {
      rb.query('catalogId', params.catalogId, {});
      rb.query('page', params.page, {});
      rb.query('limit', params.limit, {});
      rb.query('search', params.search, {});
      rb.query('categoryPath', params.categoryPath, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkPaginatedCatalogItemsDto>;
      })
    );
  }

  /**
   * Required permissions: items:read, items:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `itemCatalogsV2ControllerFindItems$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  itemCatalogsV2ControllerFindItems(
    params: {
      catalogId: number;
      page?: number;
      limit?: number;
      search?: string;
      categoryPath?: string;
    },
    context?: HttpContext
  ): Observable<WorkPaginatedCatalogItemsDto> {
    return this.itemCatalogsV2ControllerFindItems$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPaginatedCatalogItemsDto>): WorkPaginatedCatalogItemsDto => r.body)
    );
  }

  /** Path part for operation `itemCatalogsV2ControllerFindCategoryPaths()` */
  static readonly ItemCatalogsV2ControllerFindCategoryPathsPath = '/v2/item-catalogs/{id}/categories';

  /**
   * Required permissions: items:read, items:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `itemCatalogsV2ControllerFindCategoryPaths()` instead.
   *
   * This method doesn't expect any request body.
   */
  itemCatalogsV2ControllerFindCategoryPaths$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<string>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkItemCatalogsV2Service.ItemCatalogsV2ControllerFindCategoryPathsPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<string>>;
      })
    );
  }

  /**
   * Required permissions: items:read, items:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `itemCatalogsV2ControllerFindCategoryPaths$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  itemCatalogsV2ControllerFindCategoryPaths(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<Array<string>> {
    return this.itemCatalogsV2ControllerFindCategoryPaths$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<string>>): Array<string> => r.body)
    );
  }

  /** Path part for operation `itemCatalogsV2ControllerFindImportStatus()` */
  static readonly ItemCatalogsV2ControllerFindImportStatusPath = '/v2/item-catalogs/{id}/import-status';

  /**
   * Required permissions: items:read, items:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `itemCatalogsV2ControllerFindImportStatus()` instead.
   *
   * This method doesn't expect any request body.
   */
  itemCatalogsV2ControllerFindImportStatus$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkCatalogImportProgressDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkItemCatalogsV2Service.ItemCatalogsV2ControllerFindImportStatusPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkCatalogImportProgressDto>;
      })
    );
  }

  /**
   * Required permissions: items:read, items:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `itemCatalogsV2ControllerFindImportStatus$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  itemCatalogsV2ControllerFindImportStatus(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkCatalogImportProgressDto> {
    return this.itemCatalogsV2ControllerFindImportStatus$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkCatalogImportProgressDto>): WorkCatalogImportProgressDto => r.body)
    );
  }

  /** Path part for operation `itemCatalogsV2ControllerStartImport()` */
  static readonly ItemCatalogsV2ControllerStartImportPath = '/v2/item-catalogs/import';

  /**
   * Required permissions: items:create, items:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `itemCatalogsV2ControllerStartImport()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  itemCatalogsV2ControllerStartImport$Response(
    params: {
      body: WorkStartCatalogImportDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkCatalogSummaryDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkItemCatalogsV2Service.ItemCatalogsV2ControllerStartImportPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkCatalogSummaryDto>;
      })
    );
  }

  /**
   * Required permissions: items:create, items:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `itemCatalogsV2ControllerStartImport$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  itemCatalogsV2ControllerStartImport(
    params: {
      body: WorkStartCatalogImportDto
    },
    context?: HttpContext
  ): Observable<WorkCatalogSummaryDto> {
    return this.itemCatalogsV2ControllerStartImport$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkCatalogSummaryDto>): WorkCatalogSummaryDto => r.body)
    );
  }

  /** Path part for operation `itemCatalogsV2ControllerPromotePreview()` */
  static readonly ItemCatalogsV2ControllerPromotePreviewPath = '/v2/item-catalogs/items/promote-preview';

  /**
   * Required permissions: items:read, items:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `itemCatalogsV2ControllerPromotePreview()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  itemCatalogsV2ControllerPromotePreview$Response(
    params: {
      body: WorkPromoteCatalogItemsPreviewDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkPromoteCatalogItemsPreviewResultDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkItemCatalogsV2Service.ItemCatalogsV2ControllerPromotePreviewPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkPromoteCatalogItemsPreviewResultDto>;
      })
    );
  }

  /**
   * Required permissions: items:read, items:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `itemCatalogsV2ControllerPromotePreview$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  itemCatalogsV2ControllerPromotePreview(
    params: {
      body: WorkPromoteCatalogItemsPreviewDto
    },
    context?: HttpContext
  ): Observable<WorkPromoteCatalogItemsPreviewResultDto> {
    return this.itemCatalogsV2ControllerPromotePreview$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPromoteCatalogItemsPreviewResultDto>): WorkPromoteCatalogItemsPreviewResultDto => r.body)
    );
  }

  /** Path part for operation `itemCatalogsV2ControllerCreateVendorContact()` */
  static readonly ItemCatalogsV2ControllerCreateVendorContactPath = '/v2/item-catalogs/vendor-contact';

  /**
   * Required permissions: items:create, items:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `itemCatalogsV2ControllerCreateVendorContact()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  itemCatalogsV2ControllerCreateVendorContact$Response(
    params: {
      body: WorkCreateVendorContactFromCatalogDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkContact>> {
    const rb = new RequestBuilder(this.rootUrl, WorkItemCatalogsV2Service.ItemCatalogsV2ControllerCreateVendorContactPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkContact>;
      })
    );
  }

  /**
   * Required permissions: items:create, items:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `itemCatalogsV2ControllerCreateVendorContact$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  itemCatalogsV2ControllerCreateVendorContact(
    params: {
      body: WorkCreateVendorContactFromCatalogDto
    },
    context?: HttpContext
  ): Observable<WorkContact> {
    return this.itemCatalogsV2ControllerCreateVendorContact$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkContact>): WorkContact => r.body)
    );
  }

  /** Path part for operation `itemCatalogsV2ControllerPromote()` */
  static readonly ItemCatalogsV2ControllerPromotePath = '/v2/item-catalogs/items/promote';

  /**
   * Required permissions: items:create, items:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `itemCatalogsV2ControllerPromote()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  itemCatalogsV2ControllerPromote$Response(
    params: {
      body: WorkPromoteCatalogItemsDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkPromoteCatalogItemsResultDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkItemCatalogsV2Service.ItemCatalogsV2ControllerPromotePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkPromoteCatalogItemsResultDto>;
      })
    );
  }

  /**
   * Required permissions: items:create, items:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `itemCatalogsV2ControllerPromote$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  itemCatalogsV2ControllerPromote(
    params: {
      body: WorkPromoteCatalogItemsDto
    },
    context?: HttpContext
  ): Observable<WorkPromoteCatalogItemsResultDto> {
    return this.itemCatalogsV2ControllerPromote$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPromoteCatalogItemsResultDto>): WorkPromoteCatalogItemsResultDto => r.body)
    );
  }

  /** Path part for operation `itemCatalogsV2ControllerApplyPriceChanges()` */
  static readonly ItemCatalogsV2ControllerApplyPriceChangesPath = '/v2/item-catalogs/price-changes/apply';

  /**
   * Required permissions: items:update, items:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `itemCatalogsV2ControllerApplyPriceChanges()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  itemCatalogsV2ControllerApplyPriceChanges$Response(
    params: {
      body: WorkApplyCatalogPriceChangesDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkCatalogPriceChangeDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkItemCatalogsV2Service.ItemCatalogsV2ControllerApplyPriceChangesPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkCatalogPriceChangeDto>>;
      })
    );
  }

  /**
   * Required permissions: items:update, items:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `itemCatalogsV2ControllerApplyPriceChanges$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  itemCatalogsV2ControllerApplyPriceChanges(
    params: {
      body: WorkApplyCatalogPriceChangesDto
    },
    context?: HttpContext
  ): Observable<Array<WorkCatalogPriceChangeDto>> {
    return this.itemCatalogsV2ControllerApplyPriceChanges$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkCatalogPriceChangeDto>>): Array<WorkCatalogPriceChangeDto> => r.body)
    );
  }

}
